import { Directive, ViewContainerRef } from "@angular/core";

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: "[custom-host]",
})
export class CustomHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
